define(function (require, exports, module) {
    'use strict';

    var _ = require('Cloud/Application/_');

    /**
     * @namespace
     */
    var thumbnailer = {
        /**
         * @param {string} extension – без точки
         * @param {string} kind
         * @param {string} hash – облачный hash файла (SHA1 + salt).
         * @param {number} size – в байтах.
         * @returns {string|undefined} – url
         */
        getThumbnail: function (extension, kind, hash, size) {
            var fakeCloudItem = {
                ext: extension.toLowerCase(),
                ext2: extension,
                kind: kind,
                hash: hash,
                size: size,
            };

            var id = '/fake.' + extension;
            var isPublic = false;
            var thumbnails = _.urls.thumbs(fakeCloudItem, id, isPublic);
            var thumbnail;

            if (thumbnails) {
                thumbnail = thumbnails.pic;
            }

            return thumbnail;
        },
    };

    module.exports = thumbnailer;
});
